module.exports = __webpack_public_path__ + "static/media/AlsaceSand.1a15ccc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/AlsaceSand.jpg
// module id = 27
// module chunks = 0